/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
import constants from './constants';

function getDeepValue(expression, context) {
  const tokens = expression.split('.');
  return tokens.reduce((tot, curr) => tot[curr], context);
}

export default {

  install(Vue) {
    Vue.prototype.$getConst = Vue.$getConst = function getConst(key, defaultValue) {
      return getDeepValue(key, constants) || defaultValue;
    };

    Vue.filter('constant', Vue.$getConst);
  },

};
